export default (targetObserver, targetLocation, offset = 0) => {

  Object.assign([], document.querySelectorAll(targetObserver)).map(el => {
    el.addEventListener('click', e => {
      const targetAnchor = document.querySelector(targetLocation);
      e.preventDefault();
      window.scroll({
        top: targetAnchor.offsetTop - offset,
        behavior: 'smooth'
      });
    });
  });
};
